// Perfiles del módulo de Obras. Mantener alineado con el API
// (book-bsk-api/BookBSK/Controllers/ObrasAccessAttribute.cs), que es quien lo hace cumplir:
// - total: Grupo Atlante (empresa 1) y la lista autorizada ("Bershka obras"). Todo.
// - imagen: Bershka Imagen (empresa 2). Ve todas las obras y solo cambia el PMI.
// - estudio: empresas de tipo 4. Solo ve, sin cambiar nada, las obras cuyo Studio es su
//   empresa (el API ya devuelve solo esas).
export const OBRAS_ROLES = { TOTAL: "total", IMAGEN: "imagen", ESTUDIO: "estudio" };

const obrasUsers = new Set([14, 15, 16, 17, 18, 19, 73, 122, 129]);
const EMPRESA_TOTAL = 1;
const EMPRESA_IMAGEN = 2;
const TIPO_EMPRESA_ESTUDIO = 4;

const numberOf = (value) => (value === null || value === undefined || value === "" ? null : Number(value));

// Perfil del usuario en Obras, o null si no tiene acceso.
export function obrasRole(user) {
    if (!user) return null;
    const codEmpresa = numberOf(user.codEmpresa ?? user.CodEmpresa);
    const codUsuario = numberOf(user.codUsuario ?? user.CodUsuario);
    const codTipoEmpresa = numberOf(user.codTipoEmpresa ?? user.CodTipoEmpresa);
    if (codEmpresa === EMPRESA_TOTAL || obrasUsers.has(codUsuario)) return OBRAS_ROLES.TOTAL;
    if (codEmpresa === EMPRESA_IMAGEN) return OBRAS_ROLES.IMAGEN;
    if (codTipoEmpresa === TIPO_EMPRESA_ESTUDIO && codEmpresa > 0) return OBRAS_ROLES.ESTUDIO;
    return null;
}

export function canAccessObras(user) {
    return obrasRole(user) !== null;
}

// Imagen y Estudio son de consulta: no crean, duplican, archivan ni gestionan catálogos.
export const isReadOnlyObrasRole = (role) => role !== OBRAS_ROLES.TOTAL;

// ¿Puede este perfil cambiar este campo de la ficha? (clave con la que se guarda: codPmi…)
export function canEditObraField(role, field) {
    if (role === OBRAS_ROLES.TOTAL) return true;
    return role === OBRAS_ROLES.IMAGEN && field === "codPmi";
}
